// @ts-nocheck
import { createApp } from "vue"
export default ({ app, el, props, router }) => {
  const a = createApp(app, props || {})
  if (router) a.use(router)
  return a.mount(el)
}
